import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { createRegisteredContext } from 'react-singleton-context';
import useSearchField from '../hooks/useSearchField';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchContext = createRegisteredContext('ContainerTableSearchContext', undefined);
export const useSearchContext = () => {
  const context = React.useContext(SearchContext);
  if (!context) {
    throw new Error('useSearchContext should be used within a SearchProvider');
  }
  return context;
};

/**
 * @ignore - internal component.
 */
export function SearchProvider(props) {
  const {
    searchValue,
    handleChangeInput
  } = useSearchField();
  const values = React.useMemo(() => ({
    searchValue,
    handleSearchInput: handleChangeInput
  }), [searchValue, handleChangeInput]);
  return /*#__PURE__*/_jsx(SearchContext.Provider, _extends({
    value: values
  }, props));
}